import { numberWithThousandSeparator } from "../libs/utils/number";

export const currencyMaskFunction = (value: string): string => {
    if (!value || value === "S/ ") {
        return "";
    }
    const numberValue = value.replace("S/ ", "").replace(/ /g, "");
    const formattedNumberValue = numberWithThousandSeparator(numberValue);
    return `S/ ${formattedNumberValue}`;
};
